import {useState} from "react";
import classNames from "classnames";
import {ClickAwayListener} from "@mui/material";
import {CountryOption} from "@/entities/country";
import {CitySelector} from "@/features/select-city";
import {useScrollDirection} from "@/features/header";
import {CountrySelector} from "@/features/select-country";
import {Email} from "@/shared/ui/Email";
import {Phone} from "@/shared/ui/Phone";
import {Svg} from "@/shared/ui/Svg";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import styles from "./HeaderTop.module.scss";

type Props = {
    countryList: CountryOption[];
};

export const HeaderTop = (
    {
        countryList = []
    }: Props
) => {
    const [connectionOpen, setConnectionOpen] = useState(false);

    const {isScrolled} = useScrollDirection();
    const containerClasses = classNames(
        styles.topContainer,
        {
            [styles.hidden]: isScrolled,
        }
    );

    const closeConnection = () => {
        setConnectionOpen(false);
    };

    const toggleConnection = () => {
        setConnectionOpen(!connectionOpen);
    };

    const phoneClick = () => {
        reachGoalYM('phone_click');
        reachGoalGA('phone_click');
    }

    return (
        <div className={containerClasses}>
            <div className={`globalContainer`}>
                <div className={styles.container}>
                    <CitySelector />
                    <div className={styles.connectionContainer}>
                        <ClickAwayListener onClickAway={closeConnection}>
                            <div className={classNames(styles.connection, {[styles.opened]: connectionOpen})}>
                                <button type={`button`} className={styles.connectionTrigger} onClick={toggleConnection}>
                                    <Svg id={`headerConnection`} className={styles.connectionIcon} />
                                    <p className={styles.connectionTitle}>Связаться с нами</p>
                                </button>
                                <div className={styles.connectionContent}>
                                    <p className={styles.connectionWorkingHours}>
                                        Время работы: с 9:00 до 17:00 (пн.-пт.)
                                    </p>
                                    <div className={styles.connectionPhones}>
                                        <Phone
                                            phone={`8 800 350-15-95`}
                                            className={styles.connectionPhone}
                                            onClick={phoneClick}
                                        />
                                        <Phone
                                            phone={`8 910 952-20-22`}
                                            className={styles.connectionPhone}
                                            onClick={phoneClick}
                                        />
                                    </div>
                                    <p className={styles.connectionText}>
                                        Звонок из любого региона России бесплатный
                                    </p>
                                    <div className={styles.connectionContacts}>
                                        <div className={styles.connectionIcons}>
                                            {/*<div className={`viber`}>*/}
                                            {/*    <a href={`viber://chat?number=%2B79109522022`}>*/}
                                            {/*        <Svg id={`viber`} className={`svg--viber`} />*/}
                                            {/*    </a>*/}
                                            {/*</div>*/}
                                            {/*<div className={`whatsapp`}>*/}
                                            {/*    <a href="https://wa.me/79109522022">*/}
                                            {/*        <Svg id={`whatsapp`} className={`svg--whatsapp`} />*/}
                                            {/*    </a>*/}
                                            {/*</div>*/}
                                            <a
                                                href="https://max.ru/u/f9LHodD0cOJrp9GGSadyrX__BRbqLq0CqQSijuZcF41L_Qe3TmiNWDBVbX4"
                                                className={styles.maxIcon}
                                            >
                                                <Svg id={`max`} className={styles.maxSvg} />
                                            </a>
                                            <a href="https://t.me/PlatinaManagerBot" className={styles.tgIcon}>
                                                <Svg id={`telegram`} className={styles.tgSvg} />
                                            </a>
                                        </div>
                                        <Email email={`help@platina-jewelry.ru`} className={styles.connectionMail} />
                                    </div>
                                </div>
                            </div>
                        </ClickAwayListener>
                    </div>
                    <div className={styles.countryContainer}>
                        <CountrySelector anchorHorizontal={`right`} countries={countryList} />
                    </div>
                </div>
            </div>
        </div>
    );
}
